import React, { useCallback } from "react";

import Form from "antd/es/form";
import { FormInstance } from "antd/es/form/hooks/useForm";
import { useIntl } from "react-intl";

import NotificationSettingValue from "@app/types/notifications/NotificationSetting";

import Card from "../Card";
import Header from "../Header";

import ActivityAssigned from "./ActivityAssigned";
import ActivityOwned from "./ActivityOwned";
import OwnedRecord from "./OwnedRecord";
import getNotesActivitiesUpdate from "./utils/getNotesActivitiesUpdate";

interface Props {
  form: FormInstance<NotificationSettingValue>;
  onToggle: () => void;
}

const NotesActivities: React.FC<Props> = ({ form, onToggle }) => {
  const intl = useIntl();
  const handleToggle = useCallback(
    (enabled: boolean) => {
      form.setFieldsValue({ notesAndActivities: getNotesActivitiesUpdate(enabled) });
      onToggle();
    },
    [form, onToggle]
  );

  return (
    <Card>
      <Form.Item hidden name="notesAndActivities">
        <div />
      </Form.Item>
      <Form.Item
        shouldUpdate={(prev, next) =>
          prev.notesAndActivities.enabled !== next.notesAndActivities.enabled
        }
      >
        {({ getFieldValue }) => (
          <Header
            checked={getFieldValue(["notesAndActivities", "enabled"])}
            description={intl.formatMessage({
              id: "settings.notifications.notesActivities.text",
              defaultMessage:
                "Receive an email notification for notes logged and activities done on records you own.",
              description: "Text of settings notifications Notes & Activities card",
            })}
            onChange={handleToggle}
            title={intl.formatMessage({
              id: "settings.notifications.notesActivities.title",
              defaultMessage: "Notes & Activities",
              description: "Title of settings notifications Notes & Activities card",
            })}
          />
        )}
      </Form.Item>
      <ActivityAssigned form={form} />
      <ActivityOwned form={form} />
      <OwnedRecord form={form} />
    </Card>
  );
};

export default NotesActivities;
